<template>
  <div class="h-results">
    <div class="h-head">
      <h2 class="m-0">Latest Dow Jones Midnight Results</h2>
    </div>
    <div class="h-body">
      <div class="row">
        <div class="col-md-4" v-for="(item, index) in items" :key="index">
          <div class="h-box">
            <div class="h-date">{{ item.lotto_date | date }}</div>
            <h2>{{ item.results | result('digit5') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("dddd, MMM DD, YYYY")
    },
    shortdate(param) {
      return moment(param).format("DD/MM/YY")
    },
    result(param, digit) {
      if (param) {
        let results = param
        return results[digit]
      } else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss">
.h-results {
  margin-bottom: 15px;
  color: #FFFFFF;

  .h-head {
    padding: 0 5px;
    background-color: #A90B03;
    padding: 4px;
    border-radius: 5px;

    h2 {
      color: #FFFFFF;
      font-size: 1.2rem;
    }
  }

  .h-body {
    margin-top: 10px;

    .h-box {
      padding: 5px;
      background-color: #DEE4EA;
      border-radius: 10px;
      margin: 15px 0 15px 0;
      opacity: 0.8;
      border: 1px solid #3466CD;

      .h-date {
        color: #222222;
      }

      h2 {
        margin: 0;
        color: #111111;
        letter-spacing: 2px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}

@media only screen and (max-width:767px) {
  .h-results {
    .h-body {
      width: 80%;
      margin: 15px auto;
    }
  }
}
</style>
